import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject, input } from '@angular/core';
import { Observable } from 'rxjs';
import { MenuService } from '../../../services/menu/menu.service';
import { FlyoutType } from '../../../domain/menu.domain';

/**
 * The Menu Item Content Component
 *
 * This component contains the content of the menu item
 */
@Component({
  selector: 'td-wb-menu-item-content',
  templateUrl: 'item-content.component.html',
  styleUrls: ['item-content.component.scss'],
  imports: [
    AsyncPipe
  ],
  host: {
    '[class]': 'className'
  }
})
export class MenuItemContentComponent implements OnInit {
  private readonly menuService = inject(MenuService);

  readonly flyoutType = input<FlyoutType>(undefined);

  /**
   * Class for item inner content
   */
  readonly contentType = input<string>(undefined);

  readonly singleColumn = input<boolean>(false);

  className: string;

  /**
   * Class for item inner content
   */
  itemContentInnerClass: string;

  menuWidthChange$: Observable<number>;

  /**
   * Class for item content
   */
  private itemContentClass: string;

  ngOnInit(): void {
    const flyoutType = this.flyoutType();
    if (flyoutType !== undefined) {
      this.itemContentClass = 'td-wb-nav__' + flyoutType + '__content';
      this.itemContentInnerClass = 'td-wb-nav__' + flyoutType + '__content__inner';
    }
    const contentType = this.contentType();
    if (flyoutType !== undefined && contentType !== undefined) {
      this.itemContentInnerClass += ' td-wb-nav__' + flyoutType + '__content__inner--' + contentType;
    }

    const singleColumn = this.singleColumn();
    if (!singleColumn) {
      this.menuWidthChange$ = this.menuService.onMenuWidthChangeSubject;
    }

    this.className = this.itemContentClass + ' td-wb-menu-item-content';

    if (singleColumn) {
      this.className += ' td-wb-menu-item-content-single-column';
    }
  }
}
